module.exports = __webpack_public_path__ + "static/media/celebration.94f4f0c5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/static/celebration.jpeg
// module id = 279
// module chunks = 0